import styled from 'styled-components';

const PaginationStyle = styled.div`
	--paginationMargin: var(--sp1x) 0 0 0;

	.pagination__list {
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}

	.dots {
		margin: 0 var(--sp2x);
	}

	.pagination-item {
		opacity: 60%;
		transition: var(--trTime2);
		margin: 0 var(--sp2x);
		cursor: pointer;

		&:hover {
			opacity: 100%;
			color: var(--mainBlue);
		}

		&.activePage {
			pointer-events: none;
			opacity: 100%;
		}
	}

	.dots {
		opacity: 60%;
	}

	.disable {
		pointer-events: none;
		opacity: 60%;
	}

	.next-btn,
	.prev-btn {
		cursor: pointer;

		&:hover {
			color: var(--primaryColor1);
		}

		&.disable {
			display: none;
		}
	}

	.prev-btn {
		margin-right: var(--sp1x);
		transform: rotate(90deg);
	}
	.next-btn {
		margin-left: var(--sp1x);
		transform: rotate(-90deg);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
		.dots {
			margin: 0 var(--sp1x);
		}

		.pagination-item {
			margin: 0 var(--sp1x);
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		.dots {
			margin: 0 var(--sp2x);
		}

		.pagination-item {
			margin: 0 var(--sp2x);
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.LaptopSize}) {
		.dots {
			margin: 0 var(--sp2x);
		}

		.pagination-item {
			margin: 0 var(--sp2x);
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.LaptopSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		--paginationMargin: var(--sp1x) 0 0 0;

		.dots {
			margin: 0 var(--sp2x);
		}

		.pagination-item {
			margin: 0 var(--sp2x);
		}
	}
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
		--paginationMargin: var(--sp5x) 0 0 0;

		.dots {
			margin: 0 var(--sp1x);
		}

		.pagination-item {
			margin: 0 var(--sp1x);
		}
	}
`;

export default PaginationStyle;
